import Promise from 'bluebird';
import _ from 'underscore';

function TiersController(inventoryService, $q) {
  const vm = this;

  if (!vm.inventory) throw new Error('inventory is required');

  vm.config = vm.config || {};
  vm.config.save = function () {
    return vm.saveTiers();
  };

  vm.tiers = vm.config.tiers || [];

  vm.addTier = function addTier($event) {
    if ($event) $event.preventDefault();

    const lastTier = vm.tiers[vm.tiers.length - 1];

    const newTier = {
      name: `Tier ${(vm.tiers.length + 1)}`,
      price: lastTier ? lastTier.price : vm.inventory.price,
      quantity: lastTier ? lastTier.quantity : vm.inventory.quantity,
      unsaved: true,
      deleted: false
    };

    vm.tiers.push(newTier);
  };

  vm.disableActiveAndPreviousTiers = function (tier) {
    if (!tier) return true;

    const activeTier = _.find(vm.tiers, {
      _id: vm.inventory.tier.activeLevel
    });
    const activeTierIndex = vm.tiers.indexOf(activeTier);
    const tierIndex = vm.tiers.indexOf(tier);

    return tierIndex <= activeTierIndex;
  };

  vm.areTiersValid = function () {
    const validTiers = _.filter(vm.tiers, tier => tier.price && tier.quantity);
    return validTiers.length === vm.tiers.length;
  };

  vm.saveTiers = function saveTiers($event) {
    if ($event) $event.preventDefault();

    vm.submitted = true;

    if (!vm.areTiersValid()) return null;

    const tiers = _.sortBy(vm.tiers, tier => tier.price);

    return $q.resolve(Promise.mapSeries(tiers, tier => {
      if (tier.unsaved) {
        return inventoryService.createTierById(vm.inventory.id, {
            price: tier.price,
            quantity: tier.quantity
          })
          .then(updatedInventory => {
            const newTier = updatedInventory.tier.levels[updatedInventory.tier.levels.length - 1];

            _.extend(tier, newTier);

            tier.unsaved = false;
            tier.updated = false;

            return updatedInventory;
          });
      } else if (tier.updated) {
        return inventoryService.updateTierById(vm.inventory.id, tier.id, {
            price: tier.price,
            quantity: tier.quantity
          })
          .then(() => {
            tier.updated = false;
          });
      } else if (tier.deleted) {
        return inventoryService.deleteTierById(vm.inventory.id, tier.id);
      }

      return Promise.resolve();
    }));
  };

  vm.removeTier = function removeTier(tier) {
    if (!tier || (vm.inventory.tier.activeLevel && vm.inventory.tier.activeLevel === tier.id) || vm.disableActiveAndPreviousTiers(tier)) return;

    if (tier.unsaved) {
      const tierIndex = vm.tiers.indexOf(tier);

      if (tierIndex >= 0) {
        vm.tiers.splice(tierIndex, 1);
      }
    } else {
      tier.deleted = true;
    }
  };
}

TiersController.$inject = [
  'jsSdk.inventory',
  '$q'
];

export default TiersController;



// WEBPACK FOOTER //
// ./src/directives/tiers/controller.js